module.exports = __webpack_public_path__ + "img/logo1.15bf3b0b.svg";